import { HeroComponent } from './hero/hero.component';

export const Components = [
	HeroComponent,
];
